import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IFilesArray,
  Insurer,
  IPolicies,
  IStepTree,
  TError,
} from "./types/StepTree-interface";
import {
  fetchCreateInsuranceContractProjects,
  fetchCreateInsuranceContracts,
} from "./action/fetch-step-tree";

const initialState: IStepTree = {
  SaveProject: {
    isLoadingSaveProject: false,
    errorSaveProjects: [],
    ID: "",
    PayLink: "",
  },
  Files: {
    isLoadingFiles: false,
    Files: [],
    errorFiles: [],
    Insurer: {
      Email: "",
    },
    Policies: [],
  },
};

export const StepTreeSlice = createSlice({
  name: "StepTreeSlice",
  initialState,
  reducers: {
    updateField: (
      state,
      action: PayloadAction<{
        field: keyof IStepTree;
        value: IStepTree[keyof IStepTree];
      }>
    ) => {
      const { field, value } = action.payload;
      state[field] = value as never;
    },
    resetForm: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCreateInsuranceContractProjects.pending, (state) => {
        state.SaveProject.isLoadingSaveProject = true;
      })
      .addCase(
        fetchCreateInsuranceContractProjects.fulfilled,
        (
          state,
          action: PayloadAction<{ InvoiceID: string; InvoicePayLink: string }>
        ) => {
          state.SaveProject.PayLink = action.payload.InvoicePayLink;
          state.SaveProject.ID = action.payload.InvoiceID;
          state.SaveProject.isLoadingSaveProject = false;
          state.SaveProject.errorSaveProjects = [];
        }
      )
      .addCase(
        fetchCreateInsuranceContractProjects.rejected,
        (state, action) => {
          state.SaveProject.PayLink = initialState.SaveProject.PayLink;
          state.SaveProject.ID = initialState.SaveProject.ID;
          state.SaveProject.isLoadingSaveProject = false;
          state.SaveProject.errorSaveProjects = action.payload as TError;
        }
      )

      .addCase(fetchCreateInsuranceContracts.pending, (state) => {
        state.Files.isLoadingFiles = true;
      })
      .addCase(
        fetchCreateInsuranceContracts.fulfilled,
        (
          state,
          action: PayloadAction<{
            Files: IFilesArray[];
            Insurer: Insurer;
            Policies: IPolicies[];
          }>
        ) => {
          state.Files.Files = action.payload.Files;
          state.Files.Insurer = action.payload.Insurer;
          state.Files.Policies = action.payload.Policies;
          state.Files.isLoadingFiles = false;
          state.Files.errorFiles = [];
        }
      )
      .addCase(fetchCreateInsuranceContracts.rejected, (state, action) => {
        state.Files.Files = initialState.Files.Files;
        state.Files.Insurer = initialState.Files.Insurer;
        state.Files.Policies = initialState.Files.Policies;
        state.Files.isLoadingFiles = false;
        state.Files.errorFiles = action.payload as TError;
      });
  },
});

export const { updateField } = StepTreeSlice.actions;
export default StepTreeSlice.reducer;
